import { Link } from "react-router-dom";
import { Rodape } from "@/features/landing/components/Rodape";

export function ChamadaFinal({
  titulo = "Conecte seu número e atenda o próximo cliente aqui.",
}: {
  titulo?: string;
}) {
  return (
    <section className="lp-final">
      <div className="lp-largura">
        <p className="lp-rotulo lp-rotulo-ponto">Começa hoje</p>
        <h2 className="lp-final-titulo">{titulo}</h2>

        <div className="lp-final-acoes">
          <Link to="/criar-conta" className="lp-btn lp-btn-principal">
            Criar conta
          </Link>
          <Link to="/entrar" className="lp-btn lp-btn-secundario">
            Entrar
          </Link>
        </div>
      </div>

      <div className="lp-largura">
        <Rodape />
      </div>

      <div className="lp-listra" />
    </section>
  );
}
